export function createGlobalAdminHelpPopup (globalAdminNames) {
  // An arbitrary cap to keep the alert message from getting too long
  const maxDisplayedGlobalAdmins = 20

  // Intl.ListFormat() is basically a fancy .join(', ') but it will also add 'or' before the last element
  const listFormatter = new Intl.ListFormat('en', { style: 'long', type: 'disjunction' })
  alert('To get permissions for a different domain (or a new domain), ask a global admin to assign you more permissions.' +
    '\n\nHere are some global admins you could ask: ' + listFormatter.format(globalAdminNames.slice(0, maxDisplayedGlobalAdmins)))
}
